import standardAPI from '@/api/standard_items';

const responseUrl = '/blog/articles';

const state = {
  articles: [],
  articles_MetaData: {},
  articles_status: '',
  articles_page: 1,
  articles_perPage: 10,
};

const getters = {
  get_articles: (state) => {
    return state.articles;
  },
  get_articles_status: (state) => {
    return state.articles_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_articles ({ commit }, getOptions) {
    commit('DATA_ARTICLES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_ARTICLES_UPDATE_SUCCESS', response);
            commit('DATA_ARTICLES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_ARTICLES_READY');
            reject(response);
          } else {
            commit('DATA_ARTICLES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_articles_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_article ({ commit, dispatch }, itemData) {
    commit('DATA_ARTICLES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_ARTICLES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_ARTICLES_READY');
          reject(response);
        }
      });
    });
  },
  edit_article ({ commit, dispatch }, itemData) {
    commit('DATA_ARTICLES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_ARTICLES_REQUEST');
          resolve(response);
        } else {
          commit('DATA_ARTICLES_READY');
          reject(response);
        }
      });
    });
  },
  remove_articles ({ commit, dispatch }, itemData) {
    commit('DATA_ARTICLES_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_ARTICLES_REQUEST');
          resolve();
        } else {
          commit('DATA_ARTICLES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_article ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve();
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.articles_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.articles_perPage = max;
  },
  DATA_ARTICLES_READY: (state) => {
    state.articles_status = 'ready';
  },
  DATA_ARTICLES_REQUEST: (state) => {
    state.articles_status = 'loading';
  },
  DATA_ARTICLES_UPDATE_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.articles_MetaData.meta = response.meta;
      state.articles_MetaData.links = response.links;
    }
    state.articles = response.data;
    state.articles_status = 'success';
  },
  DATA_ARTICLES_ERROR: (state) => {
    state.articles_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
